import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function getAllTeamMeta() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETTEAMMETA,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function addTeamMeta(payload:any) {

  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.AddSUBTEAM, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateTeamMeta(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATETEAM, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deleteTeamMeta(teamId: string) {
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(urls.DELETETEAMMETA + teamId, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getTeamMetaByID(teamId: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETTEAMMETA + teamId, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}